<template>
  <div class="change-phone-email-hint">
    <div class="change-phone-email-hint__icon">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="9" fill="#DBE7FD" />
        <path
          d="M9.72815 11.3433H8.27183V10.5033C8.27183 10.1362 8.31049 9.86537 8.38782 9.69096C8.47373 9.50737 8.65416 9.26871 8.9291 8.97496L9.86992 7.96982C10.0675 7.74033 10.1663 7.45577 10.1663 7.11613C10.1663 6.77649 10.0632 6.49652 9.85703 6.27622C9.65082 6.04673 9.38447 5.93199 9.05798 5.93199C8.73149 5.93199 8.45655 6.04214 8.23316 6.26245C8.01837 6.47357 7.89378 6.75814 7.85942 7.11613H6.29999C6.38591 6.29917 6.68233 5.6612 7.18925 5.20223C7.70476 4.73408 8.34486 4.5 9.10953 4.5C9.87421 4.5 10.4971 4.7249 10.9783 5.17469C11.4594 5.6153 11.7 6.23491 11.7 7.03352C11.7 7.58428 11.5582 8.04325 11.2747 8.41043C11.1114 8.63074 10.9869 8.78679 10.9009 8.87858C10.815 8.97038 10.699 9.08971 10.553 9.23658C10.4155 9.37427 10.2952 9.49819 10.1921 9.60834C10.0976 9.70932 10.0203 9.79652 9.96013 9.86996C9.80548 10.0719 9.72815 10.3565 9.72815 10.7236V11.3433ZM9.01932 14.4C8.75297 14.4 8.52099 14.3036 8.32338 14.1108C8.12576 13.9089 8.02696 13.6702 8.02696 13.3949C8.02696 13.1103 8.12147 12.867 8.31049 12.6651C8.5081 12.4631 8.74008 12.3622 9.00643 12.3622C9.28137 12.3622 9.51765 12.4631 9.71526 12.6651C9.91288 12.8579 10.0117 13.0965 10.0117 13.3811C10.0117 13.6565 9.91288 13.8951 9.71526 14.0971C9.52624 14.299 9.29426 14.4 9.01932 14.4Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="change-phone-email-hint__content">
      <div class="change-phone-email-hint__text">
        {{ $t('user-profile.hints.change-phone-email.text') }}
      </div>
      <div class="change-phone-email-hint__button" @click="goToSupportChat">
        <div class="change-phone-email-hint__button-text">
          {{ $t('user-profile.hints.change-phone-email.button') }}
        </div>
        <arrow-button
          class="change-phone-email-hint__button-arrow"
        ></arrow-button>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { SupportService } from '@js-app/services/support/support-service'

export default {
  name: 'ChangePhoneEmailHint',
  components: { ArrowButton },
  methods: {
    goToSupportChat() {
      SupportService.goToTelegramChat()
    },
  },
}
</script>

<style lang="scss" scoped>
.change-phone-email-hint {
  max-width: 310px;
  padding: 18px 12px 27px 19px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(225, 235, 253, 0.38);
  border-radius: 12px;
  border: 1px solid #f4f3fc;
  display: flex;
  align-items: flex-start;
  &__icon {
    width: 19px;
    height: 19px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    margin-left: 14px;
  }

  &__text {
    font-weight: 500;
    font-size: 10px;
    line-height: 18px;
    color: #67768a;
    margin-bottom: 10px;
  }

  &__button {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &-text {
      font-weight: 500;
      font-size: 10px;
      line-height: 18px;
      color: #64748B;
    }

    &-arrow {
      width: 18px;
      height: 18px;

      margin-left: 10px;
      border-radius: 6px;
    }
  }
}
</style>
